import { collections, rankingItems } from '@/mocks/home';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-secondary-500',
  flat: 'ri-subtract-line text-foreground-400',
};

export default function RankAndCollections() {
  return (
    <section id="rank" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div id="collections" className="lg:col-span-5">
            <div className="mb-6 flex items-center gap-3">
              <span className="h-6 w-1.5 rounded-full bg-accent-500"></span>
              <h2 className="font-heading text-2xl font-black text-foreground-950">吃瓜热度榜单</h2>
            </div>
            <ol className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {rankingItems.map((item) => (
                <li key={item.rank}>
                  <a
                    href="#timeline"
                    className="group flex cursor-pointer items-center gap-4 border-b border-background-200 px-5 py-4 last:border-b-0 transition-colors hover:bg-background-100"
                  >
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black ${
                        item.rank <= 3
                          ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                          : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="flex-1">
                      <span className="block text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
                        {item.title}
                      </span>
                      <span className="mt-1 inline-block rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">
                        {item.category}
                      </span>
                    </span>
                    <span className="flex shrink-0 flex-col items-end">
                      <span className="font-heading text-sm font-bold text-foreground-800">
                        {item.heat}
                      </span>
                      <i className={`${trendIcon[item.trend]} text-xs`}></i>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-7">
            <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
              <div className="flex items-center gap-3">
                <span className="h-6 w-1.5 rounded-full bg-primary-500"></span>
                <h2 className="font-heading text-2xl font-black text-foreground-950">爆料合集</h2>
              </div>
              <a
                href="#timeline"
                className="inline-flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
              >
                全部合集
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {collections.map((col) => (
                <a
                  key={col.id}
                  href="#timeline"
                  className="group cursor-pointer overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
                >
                  <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
                    <img
                      src={col.cover}
                      alt={col.title}
                      title={`51黑料网 ${col.title}`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                    <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-semibold text-foreground-800">
                      <i className="ri-folder-2-line"></i>
                      {col.count}
                    </span>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                      {col.title}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-500">{col.desc}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}